export const AUTH_FORMS = {
  LOGIN: 'LOGIN',
  SPECIAL_LOGIN: 'SPECIAL_LOGIN',
  REGISTER: 'REGISTER',
  REGISTER_PRIVATE: 'REGISTER_PRIVATE',
  REGISTER_BUSINESS: 'REGISTER_BUSINESS',
  PASSWORD: 'PASSWORD',
  LOST_PASSWORD: 'LOST_PASSWORD',
  RESET_PASSWORD: 'RESET_PASSWORD',
};
